import { RunWithPosition } from "types/generated";

export const generateRunLink = (queuedRun: RunWithPosition) => {
  return `/${queuedRun.isModule ? "module" : "stack"}/${queuedRun.stackId}${
    queuedRun.isModule && queuedRun.version ? `/version/${queuedRun.version}` : ""
  }/run/${queuedRun.run.id}`;
};
